module.exports = "/static/assets/ddf1e5c0c982e9536d539fbf8e2c738f.png";